import React from 'react';

import { Flex } from '@rover/kibble/core';
import Carousel from '@rover/react-lib/src/pages/home/RoverProtect/components/Carousel';

import { getCarouselData, widthArray } from '../RoverProtect.utils';

const TestimonialsSection = (): JSX.Element => {
  return (
    <Flex sx={{ margin: '0 auto' }} mb="24x" px="4x" width={widthArray}>
      <Flex justifyContent="center">
        <Carousel carouselData={getCarouselData()} />
      </Flex>
    </Flex>
  );
};

export default TestimonialsSection;
